import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  CONTACT_EMAIL,
  CONTACT_NAME,
  RESPONDENT_TYPE,
} from 'constants/formFields';
import { DEFAULT_OPTION } from 'constants/general';
import { addUserModalSchema } from 'utils/validators';

import type { TAddUserModalSchema } from 'utils/validators';
import type IAddUserModalForm from '../interfaces/IAddUserModalForm';

const useAddUserModalForm = ({ isPageLoading, selectedItem }: IAddUserModalForm) => {
  const {
    control,
    handleSubmit,
    formState: { isDirty, isLoading },
    reset,
    setError,
    clearErrors,
    getValues,
    watch,
    setValue,
    resetField,
  } = useForm<TAddUserModalSchema>({
    mode: 'onSubmit',
    resolver: yupResolver(addUserModalSchema),
    defaultValues: {
      [CONTACT_EMAIL]: '',
      [CONTACT_NAME]: '',
      [RESPONDENT_TYPE]: DEFAULT_OPTION,
    },
  });

  useEffect(() => {
    if (selectedItem) {
      setValue(CONTACT_EMAIL, selectedItem.email);
      setValue(CONTACT_NAME, selectedItem.name);
    }
  }, [selectedItem, setValue]);

  useEffect(() => {
    if (!isPageLoading) {
      reset();
    }
  }, [reset, isPageLoading]);

  const fieldsName = Object.keys(getValues());

  return {
    control,
    handleSubmit,
    isDirty,
    reset,
    isLoading,
    setError,
    clearErrors,
    fieldsName,
    watch,
    setValue,
    resetField,
  };
};

export default useAddUserModalForm;
